import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { VisaLanguageCreateDto, VisaLanguageUpdateDto } from '../dtos/visaLanguage/visaLanguageDto';
@Injectable({
  providedIn: 'root'
})
export class VisaLanguageService {
  private apiUrl = `${environment.apiUrl}/visaLanguage`;

  constructor(private http: HttpClient) {}

  // Get list of all visa languages
  getList(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}`);
  }

  //get by country Id
  getByCountryId(countryId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${countryId}`);
  }

  // Create a new visa language
  create(entity: VisaLanguageCreateDto): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}`, entity);
  }

  // Update an existing visa language
  update(id: number, entity: VisaLanguageUpdateDto): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, entity);
  }

  // Delete a visa language by id
  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }
}
